<template>
  <div class="member-info">
    <ei-header :header2-show="true" :header2-lit="true"></ei-header>
    <div class="top-margin"></div>
    <el-card>

    </el-card>
  </div>
</template>

<script>
export default {
  name: 'MemberInfo'
}
</script>

<style scoped>

</style>
